































































import {
  defineComponent, PropType,
} from '@vue/composition-api';
import type { RightSummaryType } from '@/api/rights/types';

interface Props {
  rightSummary: RightSummaryType;
  isRightDiscountUser: boolean;
}

export default defineComponent({
  name: 'StyleA',
  props: {
    rightSummary: {
      type: Object as PropType<RightSummaryType>,
      required: true,
    },
    isRightDiscountUser: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['tabChange', 'showRightsDetail'],
  setup(props: Props, { emit }: { emit: (event: string, ...args: unknown[]) => void }) {
    /** 处理 tab 切换 */
    const handleTabChange = () => {
      emit('tabChange');
    };

    /** 处理显示权益详情 */
    const handleShowRightsDetail = () => {
      emit('showRightsDetail', props.rightSummary);
    };

    return {
      handleTabChange,
      handleShowRightsDetail,
    };
  },
});
